"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = exports.MenuContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const hook_1 = require("../hook");
const Backdrop_1 = require("../Backdrop");
exports.MenuContainer = styled_components_1.default.div `
  display: flex;
  position: relative;
  width: 100%;
`;
const Menu = ({ children, content, useBackdrop = false, }) => {
    const ref = react_1.default.createRef();
    const [isOpen, setIsOpen] = react_1.default.useState(false);
    const onClickOutside = react_1.default.useCallback(() => {
        setIsOpen(false);
    }, [setIsOpen]);
    (0, hook_1.useDetectOutsideClick)({
        onClick: onClickOutside,
        ref,
    });
    const toggle = react_1.default.useCallback(() => {
        return setIsOpen(!isOpen);
    }, [isOpen, setIsOpen]);
    const open = react_1.default.useCallback(() => {
        return setIsOpen(true);
    }, [setIsOpen]);
    const close = react_1.default.useCallback(() => {
        return setIsOpen(false);
    }, [setIsOpen]);
    const props = react_1.default.useMemo(() => {
        return { toggle, open, close };
    }, [toggle, open, close]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [isOpen && useBackdrop && ((0, jsx_runtime_1.jsx)(Backdrop_1.Backdrop, {})), (0, jsx_runtime_1.jsxs)(exports.MenuContainer, Object.assign({ ref: ref }, { children: [children(props), isOpen && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: content(props) }))] }))] }));
};
exports.Menu = Menu;
